import { useQuery } from "@tanstack/react-query"
import { getBackofficeJobSearchQuery } from "modules/backoffice/lib/jobSearch/getBackofficeJobSearchQuery"

export function useGetBackofficeJobSearchQuery(
  ...args: Parameters<typeof getBackofficeJobSearchQuery>
) {
  return useQuery(getBackofficeJobSearchQuery(...args))
}
